import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { UsersService } from 'src/app/_services/admin/users.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { ErrorUtil } from 'src/app/_utilities/error';

@Component({
  selector: 'app-manage-user-group',
  standalone: false,
  templateUrl: './manage-user-group.component.html',
  styleUrl: './manage-user-group.component.scss'
})
export class ManageUserGroupComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  data: any;
  userGroups: any[] = [];
  submitted: boolean = false;
  saving: boolean = false;

  userGroupForm = new UntypedFormGroup({
    userGroup: new UntypedFormControl([], [Validators.required]),
  });

  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private userService: UsersService,
    private errorUtil: ErrorUtil,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
    this.loadUserGroups();
    this.userGroupForm.patchValue({
      userGroup: this.getExistingUserGroupIds(),
    });
  }

  loadUserGroups() {
    this.push(
      this.userService.getAlluserGroup().subscribe((res: any) => {
        this.userGroups = Array.isArray(res) ? res : (res?.content || res?.data || []);
      })
    );
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  onSave() {
    this.submitted = true;
    this.userGroupForm.markAllAsTouched();

    const selectedIds = this.userGroupForm.value.userGroup || [];
    if (!selectedIds.length) {
      this.userGroupForm.controls['userGroup'].setErrors({ required: true });
      return;
    }
    if (this.userGroupForm.invalid) {
      return;
    }

    const userId = this.data?.id;
    if (!userId) {
      this.errorUtil.setErrorMessage(400, null, 'User id is missing', 'error', 3000);
      return;
    }

    const body = { userGroupIds: selectedIds };

    this.saving = true;
    this.push(
      this.userService.saveUserUserGroups(userId, body).subscribe((res: any) => {
        this.saving = false;
        if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
          this.errorUtil.setErrorMessage(
            200,
            this.translate?.general.messages.savedSuccessfully,
            null,
            'success',
            1000
          );
          this.modalRef.hide();
        } else {
          this.errorUtil.setErrorMessage(
            res?.status || 400,
            null,
            res?.error?.title || res?.error?.message || null,
            'error',
            3000
          );
        }
      })
    );
  }

  private getExistingUserGroupIds(): any[] {
    if (Array.isArray(this.data?.userGroupIds)) {
      return [...this.data.userGroupIds];
    }
    if (Array.isArray(this.data?.userGroups)) {
      return this.data.userGroups
        .map((g: any) => (g?.id != null ? g.id : g))
        .filter((id: any) => id != null);
    }
    return [];
  }

  push(obs: any) {
    super.push(obs);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
